export default __webpack_public_path__ + "static/media/visity.49f66a25.PNG";